export default {
  appName: 'Claussen-Simon-Stiftung Bewerbungsportal',
  appUrl: process.env.NODE_ENV === 'production' ? `${window.location.protocol}//${window.location.host}` : `http://localhost:8000`,
  status: Object.freeze({
    IDLE: 1,
    SAVING: 2,
    ERROR: 3,
    WARNING: 4,
    SUCCESS: 5,
    LOADING: 6
  }),
  project: {
    type: Object.freeze({
      SCHOOL: 1,
      UNIVERSITY: 2
    })
  },
  sentry: {
    dsn: 'https://b6b48a164ecb4a4a948a5bca9006e7dc@sentry.lfda.de/18',
    tunnelEndpoint: '/api/bugs/',
    release: process.env.VUE_APP_SENTRY_RELEASE || '',
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || 'unknown',
    sampleRate: parseFloat(process.env.VUE_APP_SENTRY_SAMPLERATE) || 1.0
  },
  CKCONFIG: {
    toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote' ],
    heading: {
      options: [
        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' }
      ]
    }
  }
}
